import React from "react";

import { FileText } from "lucide-react";

import { EmptyState } from "~/components/ui/empty-state";

interface EmptySalesRequestsProps {
  searchActive: boolean;
}

const EmptySalesRequests: React.FC<EmptySalesRequestsProps> = ({
  searchActive,
}) => {
  return (
    <EmptyState
      icon={FileText}
      title="No hay notas de venta disponibles"
      description={
        searchActive
          ? "Intenta con otros filtros"
          : "No se encontraron notas de venta para este cliente"
      }
    />
  );
};

export default EmptySalesRequests;
